module.exports = __webpack_public_path__ + "img/frontpage-background.1f95c4ca.jpg";